// extracted by mini-css-extract-plugin
export default {"cellPadColumn":"kmuALzMwrr2IUAaSyMPG"};